import axios from "axios";
import router from '../router'
// axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
var apiBase = process.env.VUE_APP_APIDOMAIN;

const apiProxy = axios.create({
    baseURL: apiBase,//'http://3.114.243.73:8000' 正是測試位置,
    //=== 開發環境使用 ===
    // baseURL: 'http://18.182.117.182/api', //設定一般路徑都走至/api ， vue.config.js 設定 proxy 走跨域請求
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
    //=== 同意cookie ===
    withCredentials: true,
    // transformResponse: [function (data) {
    //     // 对 data 进行任意转换处理
    //     console.log('這看看');
    //     console.log(data);
    //     return data;
    // }],
});
//攔截器 - 把回傳的資料先攔截下來處理，會再回傳
apiProxy.interceptors.response.use(function (response) {
    // Do something with response data
    // console.log('回應');
    // console.log(response);
    return response;
}, function (error) {
    // Do something with response error
    console.log('錯誤');
    // console.log(error.request.response);
    console.log(error.request.status);
    if (error.request.status == '401') {
        // alert("權限問題" + error + "<br>錯誤編號：" + error.request.status);
        console.log('無權限，回首頁');
        router.push("/").catch((err) => {
            err;
        });
    }
    return Promise.reject(error);
});
// apiProxy.interceptors.request.use(function (config) {
//     // Do something before request is sent
//     console.log('設定')
//     console.log(config)
//     // return config;
// }, function (error) {
//     console.log('錯誤')
//     // Do something with request error
//     console.log(error)
//     // return Promise.reject(error);
// });

//=== 取的貨號單資訊 ===
export const apiRecordInfo = (data) => apiProxy.post('/record/info', data);
//=== 送出工程工作 ===
export const apiRecordEdit = (data) => apiProxy.post('/record/edit', data);
//=== 貨號單列表 ===
export const apiRecordList = () => apiProxy.post('/record/list');
//=== 填單紀錄 ===
export const apiRecordLog = (data) => apiProxy.post('/record/log', data);

//=== 共用 ===
//== 員工下拉單 ==
export const apiEmployeeListSelect = () => apiProxy.post('/list/employee');
